// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file.
console.log("This site was developed by https://www.sleeplessmedia.com");

(function ($) {
  $(window).ready(function () {
    //Knockout Code
    var ViewModel = function ViewModel() {
      self = this; //PDP Observables

      if (meta.pageType == 'product') {
        this.pdp_option1_selected = ko.observable("");
        this.pdp_option2_selected = ko.observable("");
        this.pdp_option3_selected = ko.observable("");
        this.pdp_color_selected = ko.observable("");
        this.pdp_quantity_selected = ko.observable(1);
        this.pdp_product_data = ko.observable({});
        this.pdp_thumbs_array = ko.observableArray([]);
        this.pdp_thumbs_visible = ko.observableArray([]);
        this.pdp_variants_meta = ko.observableArray(meta.product.variants || []);
        this.pdp_active_possibilities = ko.observableArray([]);
        this.pdp_active_option = ko.observable(1); //PDP Functions

        this.pdp_variant_selected_title = ko.computed(function () {
          return "".concat(this.pdp_option1_selected(), " / ").concat(this.pdp_option2_selected(), " / ").concat(this.pdp_option3_selected());
        }, this); //Reach out from each control input and make sure the
        //input's value is possible given the

        this.pdp_variant_selected_id = ko.computed(function () {
          var _this = this;

          var id = null;
          this.pdp_variants_meta().forEach(function (element) {
            if (element.public_title == _this.pdp_variant_selected_title()) {
              id = element.id;
            }
          });

          if (id) {
            return id;
          }
        }, this);

        this.match_with_images = function (color, option) {
          if (option == 1) {
            self.pdp_option1_selected(color);
          }

          if (option == 2) {
            self.pdp_option2_selected(color);
          }

          if (option == 3) {
            self.pdp_option3_selected(color);
          }

          var arr = self.pdp_thumbs_array();
          color = color.replace(' ', '-');
          self.pdp_thumbs_visible([]);
          arr.forEach(function (el, index) {
            if (el.toLowerCase().includes(color.toLowerCase())) {
              self.pdp_thumbs_visible.push(el);
            }
          });
        };

        this.pdp_selected_contains_me = function (data, option_number, value) {
          if (option_number != self.pdp_active_option()) {
            return self.pdp_active_possibilities().toString().includes(value);
          } else {
            return true;
          }
        };

        this.pdp_option1_value_possibilites = ko.computed(function () {
          var _this2 = this;

          var arr = [];
          this.pdp_variants_meta().forEach(function (variant) {
            if (variant.public_title.includes(_this2.pdp_option1_selected())) {
              arr.push(variant.public_title);
            }
          });
          this.pdp_active_option(1);
          this.pdp_active_possibilities(arr);
        }, this);
        this.pdp_option2_value_possibilites = ko.computed(function () {
          var _this3 = this;

          var arr = [];
          this.pdp_variants_meta().forEach(function (variant) {
            if (variant.public_title.includes(_this3.pdp_option2_selected())) {
              arr.push(variant.public_title);
            }
          });
          this.pdp_active_option(2);
          this.pdp_active_possibilities(arr);
        }, this);
        this.pdp_option3_value_possibilites = ko.computed(function () {
          var _this4 = this;

          var arr = [];
          this.pdp_variants_meta().forEach(function (variant) {
            if (variant.public_title.includes(_this4.pdp_option3_selected())) {
              arr.push(variant.public_title);
            }
          });
          this.pdp_active_option(3);
          this.pdp_active_possibilities(arr);
        }, this);

        this.pdp_increment = function () {
          self.pdp_quantity_selected(parseInt(self.pdp_quantity_selected() + 1));
        };

        this.pdp_decrement = function () {
          if (self.pdp_quantity_selected() > 1) {
            self.pdp_quantity_selected(parseInt(self.pdp_quantity_selected() - 1));
          }
        };
      } //Cart Observables



      this.articles = ko.observableArray([]);
      this.item_count = ko.observable(CartJS.cart.item_count);
      this.total_price = ko.observable(CartJS.cart.total_price);
      this.items = ko.observableArray(CartJS.cart.items);
      this.variant_id = ko.observable(0); //Cart Functions
      
      var thisThing = this;
      this.itemsContain = function(prodid){
          return ko.computed(function () {
            var newprodid = prodid / 1;
            var score = 0;
            console.log(thisThing.items);
            for (i=0;i<thisThing.items.length;i++){
              if(thisThing.items[i].id == newprodid){
				score++;
              }
            }
            
            if (score > 0){
              return true;
            }
            else{
              return false;
            }
          }, this);
      };

      this.toDollars = function (num) {
        return "$" + ( parseInt(num) / 100 ).toFixed(2);
      };

      this.clearCart = function () {
        CartJS.clear();
      };

      this.addItem = function (variantId, quantity) {
        CartJS.addItem(variantId, quantity, {}, {});
      };

      this.removeItem = function (variantId) {
        CartJS.removeItemById(variantId);
      };

      this.increment = function (line_number, quantity) {
        quantity = parseInt(quantity + 1);
        CartJS.updateItem(line_number + 1, quantity, {}, {
          "success": function success(data, textStatus, jqXHR) {
            if (data.items[line_number].quantity < quantity) {
              console.log('The requested quantity for this item is not available.');
            }
          },
          "error": function error(jqXHR, textStatus, errorThrown) {
            console.error('Error: ' + errorThrown + '!');
          }
        });
      };

      this.decrement = function (line_number, quantity) {
        if (quantity > 1) {
          quantity = parseInt(quantity - 1);
          CartJS.updateItem(line_number + 1, quantity, {}, {
            "success": function success(data, textStatus, jqXHR) {
              if (data.items[line_number].quantity < quantity) {
                console.log('The requested quantity for this item is not available.');
              }
            },
            "error": function error(jqXHR, textStatus, errorThrown) {
              console.error('Error: ' + errorThrown + '!');
            }
          });
        }
      };

      this.removeItem = function (line_number) {
        CartJS.updateItem(line_number + 1, 0, {}, {
          "success": function success(data, textStatus, jqXHR) {
            console.info('Item removed from cart.');
          },
          "error": function error(jqXHR, textStatus, errorThrown) {
            console.error('Error: ' + errorThrown + '!');
          }
        });
      };

      this.enterQuantity = function (line_number, quantity, item, event) {
        var self = this;

        if (quantity >= 1) {
          CartJS.updateItem(line_number, quantity, {}, {
            "success": function success(data, textStatus, jqXHR) {},
            "error": function error(jqXHR, textStatus, errorThrown) {
              console.error('Error: ' + errorThrown + '!');
            }
          });
        }
      };

      this.sortArticlesBy = function (tag) {
        var result = self.articles().filter(function (element) {
          return element.tags.includes(tag) ? true : false;
        });
        self.articles(result);
      };
    };

    ko.bindingHandlers.enterkey = {
      //this is not just an enterkey binding. It is specifically for the qty control
      init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
        var callback = valueAccessor();
        $(element).keypress(function (event) {
          var keyCode = event.which ? event.which : event.keyCode;

          if (keyCode === 13) {
            callback.call(bindingContext.$data, parseInt(bindingContext.$index() + 1), parseInt(element.value));
            return false;
          }

          return true;
        });
      }
    };
    ko.applyBindings(new ViewModel()); //Everytime a request to CartJS is finished, sync the view model with CartJS.

    $(document).on('cart.requestComplete', function (event, cart) {
      ko.dataFor(document.body).items(CartJS.cart.items);
      ko.dataFor(document.body).total_price(CartJS.cart.total_price);
      ko.dataFor(document.body).item_count(CartJS.cart.item_count);
    }); //End Knockout Code
    // Let the document know when the mouse is being used

    document.body.addEventListener("mousedown", function () {
      document.body.classList.add("using-mouse");
    });
    document.body.addEventListener("keydown", function () {
      document.body.classList.remove("using-mouse");
    }); // Let the document know when page is scrolled.

    $(window).on("scroll load", function (event) {
      if ($(document).scrollTop() > 0) {
        $("body").addClass("scrolled");
      } else {
        $("body").removeClass("scrolled");
      }
    });





    $('.navBottom__link').hover(function(){
      $(this).find('.nav__dropdown-content').show();
    },
    function(){
      $(this).find('.nav__dropdown-content').hide();
    });
    console.log('test');

    /* as low as amount rendering */
//  console.log(breadProdLib);
//  var breadProductID;
//  var breadProductPrice;
//  var breadProductTitle;
//  var breadProductSKU;
//  var breadProductImage;
//  var breadProductURL;
//  $.each( breadProdLib, function( key, value ) {
//      console.log(value.id);
//      breadProductID = value.id;
//      breadProductPrice = parseInt(value.price);
//      breadProductTitle = value.title;
//      breadProductSKU = value.sku;
//      breadProductImage = value.image;
//      breadProductURL = value.url;

//    });
//  bread.asLowAs([
//      {
//          customTotal: breadProductPrice,
//      id: breadProductID // optional

//  }
//  ], function (data, err) {
//      if (err) {
//          console.error(err);
//          return;
//      }
//      data.forEach(function (item) {
//          console.log(item);
//          const asLowAs = item.asLowAs;
//          const el = document.getElementsByClassName("bread-as-low-as");
//          console.log(el);
//          $( ".bread-as-low-as" ).html('' + asLowAs.amount + ' <span id="financing-disclosure">*</span>');
//          //el.innerHTML = 'As low as ' + asLowAs.amount + ' / Month <span id="financing-disclosure">*</span>';
//      });
//  });
//  /* Prequalify button click */
//  var opts = {
//      buttonId: 'phpMain__learnMoreLink',
//      actAsLabel: false,
//      asLowAs: true,
//      allowCheckout: false,
//      items: [
//          {
//              name: breadProductTitle,
//              price: breadProductPrice,
//      sku: breadProductSKU,
//      imageUrl: breadProductImage,
//      detailUrl: breadProductURL,
//      quantity: 1
//  }]
//  };
//  var elements = document.getElementsByClassName("phpMain__learnMoreLink");

//  var myFunction = function() {
//  console.log("in function");
//  console.log()
//      opts.done = function (err, tx_token) {
//          if (err) {
//              console.error("There was an error: " + err);
//              return;
//          }
//          if (tx_token !== undefined) {
//              console.log(tx_token);
//              var i = document.createElement('input');
//              i.type = 'hidden';
//              i.name = 'token';
//              i.value = tx_token;
//              var f = document.createElement('form');
//              f.action = '[REPLACEMEWITHSERVICEURL]';
//              f.method = 'POST';
//              f.appendChild(i);
//              document.body.appendChild(f);
//              f.submit();
//          }
//          return;
//      };
//      bread.showCheckout(opts);
//  };
//  for (var i = 0; i < elements.length; i++) {
//  elements[i].addEventListener('click', myFunction, false);
//  }



 // document.getElementsByClassName('bread-btn').addEventListener('click', function (e) {
     
 // });
 //   bread.checkout(opts);


/*

    $('.nav__dropbtn').mouseenter(function () {
      $(this).parent().find('.nav__dropdown-content').show();

      $('.nav__logo').removeClass('nav--logoWhite');
      $('.nav__logo').addClass('nav--logoBlue');
    
      $('.nav__container').removeClass('bgColor--transparent')
      $('.nav__container').addClass('bgColor--white');
    
      $('.navBottom__link').removeClass('color--white');
      $('.navBottom__link').addClass('color--darkGreyBlue');
 
      $(this).parent().find('.nav__dropbtn').removeClass('color--white');
      $(this).parent().find('.nav__dropbtn').addClass('color--darkGreyBlue');

      $('.nav__searchIcon').removeClass('nav__searchIcon--white');
      $('.nav__searchIcon').addClass('nav__searchIcon--blue');
    
      $('.nav__cartIcon').removeClass('nav__cartIcon--white');
      $('.nav__cartIcon').addClass('nav__cartIcon--blue');
    
      $('.nav__topIcon').removeClass('color--white');
      $('.nav__topIcon').addClass('color--darkGreyBlue');
    
      $('.nav__topText').removeClass('nav__topText--white ');
      $('.nav__topText').addClass('nav__topText--blue');
    
      $('.burgerMenu').removeClass('burgerMenu--white');
      $('.burgerMenu').addClass('burgerMenu--blue');

    });
    $('.nav__dropdown-content').mouseleave(function () {
      $('.nav__dropdown-content').hide();

      $('.nav__container').removeClass('bgColor--white');
      $('.nav__logo').removeClass('nav--logoBlue');
      $('.nav__logo').addClass('nav--logoWhite');
    
      $('.navBottom__link').addClass('color--white');
      $('.navBottom__link').removeClass('color--darkGreyBlue');

      $('.nav__dropbtn').addClass('color--white');
      $('.nav__dropbtn').removeClass('color--darkGreyBlue');
    
      $('.nav__searchIcon').removeClass('nav__searchIcon--blue');
      $('.nav__searchIcon').addClass('nav__searchIcon--white');
      
      $('.nav__cartIcon').removeClass('nav__cartIcon--blue');
      $('.nav__cartIcon').addClass('nav__cartIcon--white');
    
      $('.nav__topIcon').removeClass('color--darkGreyBlue');
      $('.nav__topIcon').addClass('color--white');
    
      $('.nav__topText').removeClass('nav__topText--blue');
      $('.nav__topText').addClass('nav__topText--white ');
    
      $('.burgerMenu').removeClass('burgerMenu--blue');
      $('.burgerMenu').addClass('burgerMenu--white');

    });

*/












    jQuery('.burgerMenu').on('click', function () {
      jQuery('.navMob').addClass('navMob--open');
      jQuery('.navMob__backdrop').fadeIn();
      jQuery('.navMob--opacity').css({
        "opacity": "0"
      });
      jQuery('.navMob--opacity').css({
        "opacity": "0"
      });
      jQuery('html').addClass('noScroll');
    });

    jQuery('[slidebutton]').on('click', function () {
      var index = jQuery(this).attr('slidebutton');
      jQuery('[slidecontainer]').hide();
      jQuery('[slidecontainer="' + index + '"]').show();
      jQuery('.navMob__sled').attr('style', 'left:-100%;');
    });
    jQuery('.navMob__backBtn').on('click', function () {
      jQuery('[slidecontainer]').hide();
      jQuery('.navMob__sled').attr('style', 'left:0%;');
    });
    jQuery('.navMob__backdrop, .closeBtn').on('click', function () {
      jQuery('.navMob').removeClass('navMob--open');
      jQuery('.navMob__backdrop').fadeOut();
      jQuery('.navMob--opacityn').css({
        "opacity": "1"
      });
      jQuery('.navMob--opacity').css({
        "opacity": "1"
      });
      jQuery('html').removeClass('noScroll');
    }); // Close the dropdown menu if the user clicks outside of it

    window.onclick = function (event) {
      if (!event.target.matches('.nav__dropbtn')) {
        var dropdowns = document.getElementsByClassName('nav__dropdown-content');
        var i;

        for (i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];

          if (openDropdown.classList.contains('nav__dropdown-content--show')) {
            openDropdown.classList.remove('nav__dropdown-content--show');
          }
        }
      }
    };

    var coll = document.getElementsByClassName('navMob__collapsible text--body text--bold');
    var i;

    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener('click', function () {
        this.classList.toggle('navMob__active');
        var content = this.nextElementSibling;

        if (content.style.maxHeight) {
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }

    if ( $('.template__index').length ) {
      $( '.nav__bg' ).mouseenter( function() {
        console.log( 'entered' );
        $('.nav__logo').removeClass('nav--logoWhite');
        $('.nav__logo').addClass('nav--logoBlue');
        $('.nav__bg').removeClass('bgColor--transparent');
        $('.nav__bg').addClass('bgColor--white');
        $('.navBottom__link').removeClass('color--white');
        $('.navBottom__link').addClass('color--darkGreyBlue');
        $('.nav__dropbtn').removeClass('color--white');
        $('.nav__dropbtn').addClass('color--darkGreyBlue');
        $('.nav__searchIcon').removeClass('nav__searchIcon--white');
        $('.nav__searchIcon').addClass('nav__searchIcon--blue');
        $('.nav__cartIcon').removeClass('nav__cartIcon--white');
        $('.nav__cartIcon').addClass('nav__cartIcon--blue');
        $('.nav__topIcon').removeClass('color--white');
        $('.nav__topIcon').addClass('color--darkGreyBlue');
        $('.nav__topText').removeClass('nav__topText--white ');
        $('.nav__topText').addClass('nav__topText--blue');
        $('.burgerMenu').removeClass('burgerMenu--white');
        $('.burgerMenu').addClass('burgerMenu--blue');
      } );

       $( '.nav__bg' ).mouseleave( function() {
        console.log( 'left' );
        $('.nav__bg').addClass('bgColor--transparent');
        $('.nav__bg').removeClass('bgColor--white');
        $('.nav__logo').removeClass('nav--logoBlue');
        $('.nav__logo').addClass('nav--logoWhite');
        $('.navBottom__link').addClass('color--white');
        $('.navBottom__link').removeClass('color--darkGreyBlue');
        $('.nav__dropbtn').addClass('color--white');
        $('.nav__dropbtn').removeClass('color--darkGreyBlue');
        $('.nav__searchIcon').removeClass('nav__searchIcon--blue');
        $('.nav__searchIcon').addClass('nav__searchIcon--white');
        $('.nav__cartIcon').removeClass('nav__cartIcon--blue');
        $('.nav__cartIcon').addClass('nav__cartIcon--white');
        $('.nav__topIcon').removeClass('color--darkGreyBlue');
        $('.nav__topIcon').addClass('color--white');
        $('.nav__topText').removeClass('nav__topText--blue');
        $('.nav__topText').addClass('nav__topText--white ');
        $('.burgerMenu').removeClass('burgerMenu--blue');
        $('.burgerMenu').addClass('burgerMenu--white');
       } );
      }


    //  HEADER HIDE/CHANGE ON SCROLL 

    // set the last scroll to the same thing initially because nothing is moving yet.
    var lastScroll = $(document).scrollTop(); 
    // trigger when the window is scrolled at all.
    var currentScroll = lastScroll; 

    $(window).on('scroll load', function () {
      // if current is larger than last then we are scrolling down.
      currentScroll = $(document).scrollTop(); 

      // Don't allow negative numbers ( i.e. iOS bounce scroll at top/bottom of page ).
      if ( currentScroll >= 0 && lastScroll >= 0) {

        // If current scroll is greater than last scroll, means we're going down.
        if ( currentScroll > lastScroll && currentScroll >= 150 ) {
          $('.nav__container').css('transform', 'translateY(-100%) translate3d(0,0,0)');
          $('.nav__container').css('margin-top','0'); 
          // If it's the revers, or at 0 ( top of page ), then we're going up or have stopped moving.
        } else if (currentScroll < lastScroll || currentScroll === 0 ) {
           
          $('.nav__container').css('transform', 'translateY(0) translate3d(0,0,0)');
          if( $('.announcement__text').length ) {
            if (currentScroll === 0){
   			$('.nav__container').css('margin-top','40px');
            } else {
             $('.nav__container').css('margin-top','0'); 
            }
          }
        }
 
        if ( $('.template__index').length ) {
          // If past 150px, change the bg/colors to be visible.
          if ( currentScroll >= 150 ) {
            $('.nav__logo').removeClass('nav--logoWhite');
            $('.nav__logo').addClass('nav--logoBlue');
            $('.nav__bg').removeClass('bgColor--transparent');
            $('.nav__bg').addClass('bgColor--white');
            $('.navBottom__link').removeClass('color--white');
            $('.navBottom__link').addClass('color--darkGreyBlue');
            $('.nav__dropbtn').removeClass('color--white');
            $('.nav__dropbtn').addClass('color--darkGreyBlue');
            $('.nav__searchIcon').removeClass('nav__searchIcon--white');
            $('.nav__searchIcon').addClass('nav__searchIcon--blue');
            $('.nav__cartIcon').removeClass('nav__cartIcon--white');
            $('.nav__cartIcon').addClass('nav__cartIcon--blue');
            $('.nav__topIcon').removeClass('color--white');
            $('.nav__topIcon').addClass('color--darkGreyBlue');
            $('.nav__topText').removeClass('nav__topText--white ');
            $('.nav__topText').addClass('nav__topText--blue');
            $('.burgerMenu').removeClass('burgerMenu--white');
            $('.burgerMenu').addClass('burgerMenu--blue');
            
            if( $('.announcement__text').length ) {
			$('.nav__container').css('margin-top','0');
			} 
            
          // Otherwise, put it back to transparent white.
          } else {
            $('.nav__bg').removeClass('bgColor--white');
            $('.nav__bg').addClass('bgColor--transparent');
            $('.nav__logo').removeClass('nav--logoBlue');
            $('.nav__logo').addClass('nav--logoWhite');
            $('.navBottom__link').addClass('color--white');
            $('.navBottom__link').removeClass('color--darkGreyBlue');
            $('.nav__dropbtn').addClass('color--white');
            $('.nav__dropbtn').removeClass('color--darkGreyBlue');
            $('.nav__searchIcon').removeClass('nav__searchIcon--blue');
            $('.nav__searchIcon').addClass('nav__searchIcon--white');
            $('.nav__cartIcon').removeClass('nav__cartIcon--blue');
            $('.nav__cartIcon').addClass('nav__cartIcon--white');
            $('.nav__topIcon').removeClass('color--darkGreyBlue');
            $('.nav__topIcon').addClass('color--white');
            $('.nav__topText').removeClass('nav__topText--blue');
            $('.nav__topText').addClass('nav__topText--white ');
            $('.burgerMenu').removeClass('burgerMenu--blue');
            $('.burgerMenu').addClass('burgerMenu--white');
           
            if( $('.announcement__text').length ) {
   			$('.nav__container').css('margin-top','40px');
			} 
            
          }
        }
      }

      lastScroll = currentScroll;

    });
   
    $('.productsCarousel__carousel').slick({
      slidesToShow: 4,
      infinite: true,
      dots: false,
      arrows: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
   

    $('.homepageFeaturedController--1').on('click', function (e) {
      e.preventDefault();
      $('.productsCarousel__category').removeClass('homepageFeaturedController--active');
      $(this).addClass('homepageFeaturedController--active');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--2');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--3');
      $('.productsCarousel__sled').addClass('productsCarousel__sled--1');
    });
    $('.homepageFeaturedController--2').on('click', function (e) {
      e.preventDefault();
      $('.productsCarousel__category').removeClass('homepageFeaturedController--active');
      $(this).addClass('homepageFeaturedController--active');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--1');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--3');
      $('.productsCarousel__sled').addClass('productsCarousel__sled--2');
    });
    $('.homepageFeaturedController--3').on('click', function (e) {
      e.preventDefault();
      $('.productsCarousel__category').removeClass('homepageFeaturedController--active');
      $(this).addClass('homepageFeaturedController--active');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--1');
      $('.productsCarousel__sled').removeClass('productsCarousel__sled--2');
      $('.productsCarousel__sled').addClass('productsCarousel__sled--3');
    });
    $('.testimonials__carousel').slick({
      slidesToShow: 1,
      infinite: true,
      dots: true,
      centerMode: true,
      arrows: false
    });
    $('.slider-for').slick({
      slidesToShow: 1,
      // slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
      slidesToShow: 4,
     slidesToScroll: 1,
      vertical: true,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true,
      verticalSwiping: true,
      responsive: [{
        breakpoint: 1000,
        settings: {
          vertical: false
        }
      }, {
        breakpoint: 768,
        settings: {
          vertical: false,
          arrows: false
        }
      }, {
        breakpoint: 580,
        settings: {
          vertical: false,
          slidesToShow: 3
        }
      }, {
        breakpoint: 380,
        settings: {
          vertical: false,
          slidesToShow: 2
        }
      }]
    });
    $('.pdpVideo__overlay').on('click', function (e) {
      e.preventDefault();
      var vid = $(this).attr('href');
      $('.modal__frameInner').html(vid);
      $('.modal').fadeIn();
    });
    $('.modal__bkg').on('click', function () {
      $('.modal__frameInner').html('');
      $('.modal').fadeOut();
    });
    $('.tabContainer__tab').first().addClass('tabContainer__tab--active');
    $('.pdp__tabContent').first().show();
    $('.tabContainer__tab').on('click', function (e) {
      var screenWidth = $('.pdp__tabContent').width();
      e.preventDefault();
      var id = $(this).attr('href');
      if ( $( this ).hasClass( 'tabContainer__tab--active' ) ) {
        $(this).removeClass('tabContainer__tab--active');
        $(this).next('.pdp__tabContent').hide();
      } else {
        $(this).addClass('tabContainer__tab--active');
          if (screenWidth > 700){
            $('.tabContainer__tab').removeClass('tabContainer__tab--active');
            $(this).addClass('tabContainer__tab--active');
            $('.pdp__tabContent').hide();
          } 
        $('' + id + '').show();
      }
     
    });
    $('.tabContainer__mobile').on('change', function () {
      var id = $(this).val();
      console.log(id);
      $('.pdp__tabContent').hide();
      $('' + id + '').show();
    });
    $('.template__product .pdp__collapsible').on('click', function () {
      if ($(this).hasClass('pdp__active')) {
        $('.pdp__active').removeClass('pdp__active');
        $('.pdp__faqsContainer2').slideUp();
      } else {
        $('.pdp__active').removeClass('pdp__active');
        $(this).addClass('pdp__active');
        $('.pdp__faqsContainer2').slideUp();
        $(this).parent().find('.pdp__faqsContainer2').slideDown();
      }
    });
    
    
    $('.navMob__searchForm').on('submit', function(e){
      e.preventDefault();
      var search = $('.navMob__searchInput').val();
      window.location.href = './search?q='+search;
    });
    
    function assignSelectedVariant(){
      var selector = $('.hiddenSelector');
      var first = $('[selector="1"]');
      var second = $('[selector="2"]');
      var third = $('[selector="3"]');
      var variantString = '';
      if (!first.length){
        selector.find('option').first().prop('selected', true);
      }
      else{
        variantString += first.find('option:selected').text().trim();
        if (second.length){
          variantString += ' / ' + second.find('option:selected').text().trim();
          console.log(  )
        }
        if (third.length){
          variantString += ' / ' + third.find('option:selected').text().trim();
        }
        selector.find('option').each(function(){
          var compareString = $(this).text().trim();
          if (variantString == compareString){
            $(this).prop('selected', true);
            
            // Get the data att of the product img.
            var varImg = $(this).data( 'variant-image' );
            window.selectedVariantId = $(this).attr('value')
            $('body').trigger('mulberry-variant-change')
            // If it's not empty.
            if ( varImg ) {
              // Trigger click function on corresponding slider item.
              $( '.slider-nav [data-thumb-img="' + varImg + '"]' ).closest( '.slick-slide' ).click();
            }
          }
        });
      }
    }
    
    if ($('.template__product').length){
      assignSelectedVariant();
      
//       Extend.buttons.render('#extend-offer', {
//         referenceId: $('.hiddenSelector').val(),
//       });
      
    }
    
    async function mulberryInit() {
      let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
      let product = response.product;

      const offer = await mulberry.core.getWarrantyOffer({
        id: product.id,
        title: product.title,
        price: window.selectedVariantPrice / 100,
        detail: product
      })
      
      window.mulOffers = offer
      
      if(offer.length > 0) {
        $("#addWarrantyPrice").text("$" + offer[0]['cost'].split(".")[0])
      }
      else {
        $("#addProtectionSection").hide()
      }

     await mulberry.inline.init({
        offers: offer, 
        settings: mulberry.core.settings,
        selector: '#mulberry-inline-target',
        onWarrantyToggle: async (warranty) => {
          if (warranty.isSelected) {
			window.selectedWarranty = warranty.offer
          } else {
			window.selectedWarranty = null
          }
        }
      })
     
      let pdpModal = await mulberry.modal.init({
        offers: offer, 
        settings: mulberry.core.settings,
        onWarrantySelect: async (warranty) => {      
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: window.selectedVariantId} , warranty);
      	await CartJS.updateItemById(result.shopify_variant_id, 1)
// 		await CartJS.addItem(result.shopify_variant_id, 1, {title: product.title, variantId: window.selectedVariantId});
//       	await CartJS.getCart()
//         $('body').trigger('mulberry-remove-and-sync')
        setTimeout(() => {
          renderNewCart()
		}, 1000)
//           const result = await mulberryShop.getWarrantyVariant(warranty);
//         console.log('mulberry check : ', product.title, window.selectedVariantId, warranty)
//         await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: window.selectedVariantId} , warranty);
// 		CartJS.addItem(result.shopify_variant_id, 1, {title: product.title, variantId: window.selectedVariantId});
//           setTimeout(() => {
//             $('body').trigger('mulberry-remove-and-sync')
//           }, 2000)
// 		  setTimeout(() => {
//             renderNewCart()
//           }, 4000)
          mulberry.modal.close();
        },
        onWarrantyDecline: () => {
          mulberry.modal.close();
        }
      })
      
      window.pdpModal = pdpModal
    }
    
    $(`#showMulberryBtn`).on('click', () => {
      setTimeout(() => {
        mulberry.inline.updateOffer(window.mulOffers)
        mulberry.modal.updateOffer(window.mulOffers)    
      }, 1500)
	})
    
    document.addEventListener('mulberry-shopify:loaded', () => {
      if (window.location.href.indexOf('products') != -1) {
        mulberryInit();    
      }
    })
    
    $('body').on('mulberry-variant-change', async () => {
      if (window && !window.mulberry.core) {
        return
      }
    	let response = await mulberryShop.getProductData(
        mulberryShop.getProductUrl()
      );
      let product = response.product;

      let newVariant = product.variants.find((i) => i.id == window.selectedVariantId);
      window.mulberryVariantPrice = newVariant.price
      window.mulberryVariantId = newVariant.id
      window.selectedVariant = newVariant
      let offers = await mulberry.core.getWarrantyOffer({
        id: product.id,
        title: product.title,
        price: newVariant.price,
        detail: product,
      });

	window.mulOffers = offers
      if (offers.length > 0) {
        mulberry.inline.updateOffer(offers);
        window.pdpModal.updateOffer(offers)
        window.selectedWarranty = null
      } else {
                mulberry.inline.updateOffer(offers);
        window.pdpModal.updateOffer(offers)
      	window.selectedWarranty = 'skip'
      }
          
	})
    
    $('.pdpMain__selection select').on('change', function(){
      assignSelectedVariant();
     
//       const component = Extend.buttons.instance('#extend-offer');
      
//       component.setActiveProduct($('.hiddenSelector').val());
    });

    $('.phpMain__addToCart').on('click', async function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      
      if($('#addWarrantyPrice').html() != ""){
    ///warranty offered
        let response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
      let product = response.product;
    
      if (window.selectedWarranty == 'skip') {
      } else if (!window.selectedWarranty && window.pdpModal) {
      	window.pdpModal.open();
      } else if (window.selectedWarranty && window.pdpModal) {
        const result = await mulberryShop.getWarrantyVariant(window.selectedWarranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: window.selectedVariantId} , window.selectedWarranty);
// 		await CartJS.addItem(result.shopify_variant_id, 1, {title: product.title, variantId: window.selectedVariantId});
		await CartJS.updateItemById(result.shopify_variant_id, 1)
//         CartJS.removeItemById(result.shopify_variant_id);
//         $('body').trigger('mulberry-remove-and-sync')
        setTimeout(() => {
          renderNewCart()
		}, 1000)
        mulberry.inline.deselectOffer()
        window.selectedWarranty = null
      }
     } 


      var qty = $('.pdpCounter__input').val();
      qty = qty / 1;
      
      var timestamp = Date.now();
      
      var meta1 = $(this).attr('meta-one');
      var meta2 = $(this).attr('meta-two');
      var metaprice1 = $(this).attr('meta-one-price');
      var metaprice2 = $(this).attr('meta-two-price');
      
      
      var prodArray = [];
      
      
//       const component = Extend.buttons.instance('#extend-offer');
//       if (component){
//       var plan = component.getPlanSelection();
//       }
     
      var mainId = $('.hiddenSelector').val();
      mainId = mainId / 1;
      
      
      if (typeof meta1 !== typeof undefined && attr !== false) {
        var mainObj = {
          id: mainId,
          quantity: qty,
          /*
          properties: {
            "_timestamp": timestamp,
            "_metaone": meta1,
            "_metatwo": meta2,
            "_metaone_price": metaprice1,
            "_metatwo_price": metaprice2
          }
          */
        }
      }
      else{
        var mainObj = {
          id: mainId,
          quantity: qty,
          properties: {
            "_timestamp": timestamp
          }
        }
      }
      prodArray.push(mainObj);
      
      
//       if (plan){
//         var planTitle = plan.planId+'-'+plan.price;
//         var result = extendLibrary.filter(obj => {
//           return obj.title === planTitle;
//         });
//         var extendId = result[0].id;
//         var extendNum = extendId / 1;
//         var extendObj = {
//           id: extendNum,
//           quantity: qty,
//           properties: {
//             "_timestamp": timestamp
//           }
//         }
//         prodArray.push(extendObj);
//       }
      
      var installId = $('.hiddenSelector').find('option:selected').attr('install');
      if (installId != ''){
        installId = installId / 1
        var installObj = {
          id: installId,
          quantity: qty,
          properties: {
            "_timestamp": timestamp
          }
        }
        if ($('.addOn__installation--active').length){
        	prodArray.push(installObj);
        }
      }
      
      
      
      console.log(prodArray);
      CartJS.addItems(prodArray,
        {
          "success": function(data, textStatus, jqXHR) {
              console.log('Added!');
            $('.miniCart__model').fadeIn();
          },
          "error": function(jqXHR, textStatus, errorThrown) {
              console.log('Error: ' + errorThrown + '!');
          }
      	}
      );
      
    });
    
    $('.addOn__installation').find('.addBtn').on('click', function(){
      $('.addOn__installation').toggleClass('addOn__installation--active');
      if($(this).find('span').text() == 'Add'){
        $(this).find('span').text('Remove');
      }
      else{
        $(this).find('span').text('Add');
      }
    });
    
   
    $('.addOn__warranty').find('.addBtn').on('click', function(){
      $('.addOn__warranty').toggleClass('addOn__warranty--active');
      $('.addOn__warranty').slideToggle();
      $('.extend-wrapper').slideToggle();
    });
 
    
    $('.miniUpsellProd__add').on('click', function(){
      var realid = $(this).attr('prodid') / 1;
      var quant = $(this).parent().find('.miniUpsellProd__input').val() / 1;
      var timestamp = Date.now();
      
      CartJS.addItem(realid, quant, {"_timestamp":timestamp});
    });
    
    $('.miniUpsellProd__minus').on('click', function(){
      var newVal = $(this).parent().find('.miniUpsellProd__input').val() / 1 - 1;
      $(this).parent().find('.miniUpsellProd__input').val(newVal)
    });
    
    $('.miniUpsellProd__plus').on('click', function(){
      var newVal = $(this).parent().find('.miniUpsellProd__input').val() / 1 + 1;
      $(this).parent().find('.miniUpsellProd__input').val(newVal)
    });
    
    $('.nav__cartIcon').on('click', function(){
      if ($(this).hasClass('navMob__cartIcon')){
		window.location.href = "/cart";
      }else{
		$('.miniCart__model').fadeIn();
      }
    });
    
    $('.miniCart__close').on('click', function(){
      $('.miniCart__model').fadeOut();
    });
    
    $('[freq-id]').on('click', function(e){
      e.preventDefault();
      var freqId = $(this).attr('freq-id') / 1;
      CartJS.addItem(freqId, 1, {
          "success": function(data, textStatus, jqXHR) {
              console.log('Added!');
            $('.miniCart__model').fadeIn();
          },
          "error": function(jqXHR, textStatus, errorThrown) {
              console.log('Error: ' + errorThrown + '!');
          }
      	});
    });
    
    $('.pdpMain__selection').on('change', function(){
      var price = $('.hiddenSelector').find('option:selected').attr('price');
      var compareAtPrice = $('.hiddenSelector').find('option:selected').attr('compareAt');
     
      if (Number(compareAtPrice.replace(/[^0-9.-]+/g,"")) > Number(price.replace(/[^0-9.-]+/g,""))){
       $('.pdpMain__newPrice').css("color","red"); 
         
      } else {
       $('.pdpMain__newPrice').css("color","black");  
      }
      $('.pdpMain__newPrice').text(price);
      $('.pdpMain__oldPrice').text(compareAtPrice);
    });
    
    //?view=product.json.liquid
    var ready = true;
    $('.miniCart__list').bind("DOMSubtreeModified",function(){
      if (ready == true){
        ready = false;
        
        var items = CartJS.cart.items;
        var bagSize = items.length;
		var readyCount = 0;
        var handleArray = [];
        var installArray = [];
        var variantArray = [];
        for (i=0;i<bagSize;i++){
          handleArray.push(items[i].handle);
          variantArray.push(items[i].id);

          var getUrl = '/products/' + items[i].handle;

          $.get(getUrl, function(data, status){
            var jsonData = JSON.parse($(data).find('.jsonDataGet').html());
            installArray.push(jsonData.installId / 1);
            
            readyCount++;
            if (readyCount == bagSize){
              ready = true;
              console.log(handleArray);
              console.log(installArray);
              console.log(variantArray);
            }
            
            
          });

        }
      }
    });
    
    
    $('.miniCart__overlay').on('click', function(){
      $('.miniCart__model').fadeOut();
    });
    
    $('.stamped-product-reviews-badge').on('click', function(){
    $('.tabContainer__tab').removeClass('tabContainer__tab--active');
      $('.reviews__tab').addClass('tabContainer__tab--active');
      $('.pdp__tabContent').hide();
      $('' + '#reviews' + '').show();
    });
    
    $('.extra-faq-button').on('click', function(){
    $('.tabContainer__tab').removeClass('tabContainer__tab--active');
      $('.faq__tab').addClass('tabContainer__tab--active');
      $('.pdp__tabContent').hide();
      $('' + '#packagefaqs' + '').show();
      $(document).scrollTop( $("#tabStart").offset().top );
    });
    
    
    //new ajax cart setup --------------------------------------------
    
    
    
    //get template for prods test
    /*
	var templateHTML = $.parseHTML($('.miniCart__list').html());
    
    console.log($('.miniCart__list').html());
    $('.miniCart__list').html('');
    var templateClone = templateHTML;
    $(templateClone).find('.miniCartCard__title').text('tester tester');
    
    $('.miniCart__list').html(templateClone);
    */
    function getUpdatedCart() {
		return fetch('/cart.js', {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (cart) {
          cart.json().then(function (firstCart) {
             mulberryShop.removeDetachedWarranty(firstCart)
             .then(newCart => {
             	mulberryShop.cart.syncQuantities(newCart)
				  .then(content => {
					return content
                  })
             })
          });
        })
    }    


    //group cart by timestamp
   function groupByTimestamps(){
     
      var groupedData = [];
//      var first = await jQuery.get('/cart.js')
//      CartJS.cart = JSON.parse(first)
      var cartData = CartJS.cart.items;
      // loop through all items
      for (i=0;i<cartData.length;i++){
        var thisProd = cartData[i];
        
        // if product has a valid timestamp
        if (thisProd.properties.hasOwnProperty('_timestamp')){
          console.log(thisProd);
          // make sure that the product is not an extended service contract or an installation
          if (thisProd.vendor != 'Extend' && thisProd.vendor != 'Snap Install'){
            //create an object for this new timestamp group with current iteration as the parent product
            var iObject = {
              'index':i
            };
            // loop through all other items to compare timestamps
            for (j=0;j<cartData.length;j++){
              if (i!=j){
                var compareProd = cartData[j];
                //make sure comparison has a timestamp
				if (compareProd.properties.hasOwnProperty('_timestamp')){
                  if (compareProd.properties._timestamp == thisProd.properties._timestamp){
                    if (cartData[j].vendor == 'Extend'){
                      iObject['warranty'] = j
                    }
                    else{
                      iObject['install'] = j
                    }
                  }
                }
              }
            }
            groupedData.push(iObject);
            
          }
        }
        // if not just push it to the cart as a parent
        else{
          var iObject = {
            'index':i
          };
          groupedData.push(iObject);
        }
      }
      return groupedData;
    }
    console.log(groupByTimestamps());
    
    //get metafield data from each master product
    function getInstallVariantId(index){
      if (CartJS.cart.items[index].properties.hasOwnProperty('_metaone')){
        if (CartJS.cart.items[index].properties._metaone != ''){
          return CartJS.cart.items[index].properties._metaone;
        }
        else if(CartJS.cart.items[index].properties._metatwo != ''){
          return CartJS.cart.items[index].properties._metatwo;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
    }
    
   
    function getExtendPriceString(index){
      if (CartJS.cart.items[index].properties.hasOwnProperty('_metaone_price')){
        if (CartJS.cart.items[index].properties._metaone_price != ''){
          return CartJS.cart.items[index].properties._metaone_price;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
      
    }
   
    
    function getInstallPriceString(index){
      if (CartJS.cart.items[index].properties.hasOwnProperty('_metatwo_price')){
        if (CartJS.cart.items[index].properties._metatwo_price != ''){
          return CartJS.cart.items[index].properties._metatwo_price;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
    }
    
    var templateHTML = $('.miniCart__list').html();
    
    function buildProdCard(parentIndex, childIndex1, childIndex2){
      var parentProd = CartJS.cart.items[parentIndex];
      var parentProd = CartJS.cart.items[parentIndex];      
      
      if (childIndex1 != 'empty'){
      var childProd1 = CartJS.cart.items[childIndex1];
      }
      else{
        var childProd1 = false
      }
      
      if (childIndex2 != 'empty'){
      	var childProd2 = CartJS.cart.items[childIndex2];
      }
      else{
        var childProd2 = false
      }
      
      var obj = {
        'image':parentProd.featured_image.url,
        'alt':parentProd.featured_image.alt,
        'timestamp':parentProd.properties._timestamp,
        'parent_index':parentIndex,
        'title':parentProd.product_title,
        'variant':parentProd.variant_title,
        'qty':parentProd.quantity,
        'price':parentProd.price,
        'parent_id':parentProd.id,
        
        'warranty_price_empty':getExtendPriceString(parentIndex),
        
        'install_price_empty':getInstallPriceString(parentIndex),
        'install_id':getInstallVariantId(parentIndex)
      }
      if (childProd1){
      	obj['warranty_index'] = childIndex1;
        obj['warranty_title'] = childProd1.product_title;
        obj['warranty_price'] = childProd1.price;
      }
      if (childProd2){
        obj['install_index'] = childIndex2;
        obj['install_title'] = childProd2.product_title;
        obj['install_price'] = childProd2.price;
      }
      
      let templateClone = $.parseHTML(templateHTML);
      
      $(templateClone).find('.miniCartCard__img').attr('src', obj.image);
      $(templateClone).find('.miniCartCard__img').attr('alt', obj.alt);
      $(templateClone).find('.miniCartCard__delete ').attr('parent-index', obj.parent_index);
      $(templateClone).find('.miniCartCard__delete ').attr('data-id', obj.parent_id);
      $(templateClone).find('.miniCartCard__title').text(obj.title);
      $(templateClone).find('.miniCartCard__variant').text(obj.variant);
      $(templateClone).find('.miniCartCard__quant').find('input').val(obj.qty).attr('value', obj.qty);
      var displayPrice = (parseFloat(obj.price) / 100).toFixed(2);
      $(templateClone).find('.miniCartCard__priceRow').find('span').text("$"+displayPrice);
      $(templateClone).find('.addExtended').attr('prodid', obj.parent_id);
      $(templateClone).find('.addExtended').attr('timestamp', obj.timestamp);
      $(templateClone).find('.addExtend__price').text(obj.warranty_price_empty);
      $(templateClone).find('.addInstall').attr('prodid', obj.install_id);
      $(templateClone).find('.addInstall').attr('timestamp', obj.timestamp);
      $(templateClone).find('.addInstall__price').text(obj.install_price_empty);
      $(templateClone).attr('data-mulberry-variant-id', obj.parent_id);
      $(templateClone).find('.miniCartCard__addOns').html(`<warranty-details data-variant-id="${obj.parent_id}"></warranty-details>`);
      if (parentProd.vendor == 'Mulberry') {
        $(templateClone).attr('style', 'display: none');
      }
      if (obj.install_id == false){
        $(templateClone).find('.addInstall').hide();
      }
     
      if (obj.warranty_price_empty == false){
        $(templateClone).find('.addExtended').hide();
      }
      
      if (obj.hasOwnProperty('warranty_index')){
        $(templateClone).find('.addExtended').hide();
        $(templateClone).find('.miniCartCard__delete ').attr('warranty-index', obj.warranty_index);
        $(templateClone).find('.removeExtend').attr('prodindex', obj.warranty_index);
        $(templateClone).find('.removeExtend__title').text(obj.warranty_title);
        var extendPrice = (parseFloat(obj.warranty_price) / 100).toFixed(2);
      	$(templateClone).find('.removeExtend__price').text('$'+extendPrice);
      }
      else{
        $(templateClone).find('.removeExtend').hide();
      }
     
      if (obj.hasOwnProperty('install_index')){
        $(templateClone).find('.addInstall').hide();
        $(templateClone).find('.miniCartCard__delete ').attr('install-index', obj.install_index);
        $(templateClone).find('.removeInstall').attr('prodindex', obj.install_index);
        $(templateClone).find('.removeInstall__title').text(obj.install_title);
        var installPrice = (parseFloat(obj.install_price) / 100).toFixed(2);
      	$(templateClone).find('.removeInstall__price').text('$'+installPrice);
      }
      else{
        $(templateClone).find('.removeInstall').hide();
      }
      
      return templateClone;
    }
    
    function htmlToSource(selector){
     return $('<div />').append($(selector).clone()).html();
    };
    
    async function renderNewCart(cart){
      $('.miniCart__list').html('');
      var newCartHTML = '';
      var grouped = groupByTimestamps();
      for (i=0;i<grouped.length;i++){
        
        if (grouped[i].warranty == null){
          var warranty = 'empty';
        }
        else{
          var warranty = grouped[i].warranty;
        }
        
        if (grouped[i].install == null){
          var install = 'empty';
        }
        else{
          var install = grouped[i].install;
        }
        
//         await CartJS.getCart()
          newCartHTML += htmlToSource(buildProdCard(grouped[i].index, warranty, install));
      }
      $('.miniCart__list').html(newCartHTML);
      if (window && window.mulberryShop) {      
        mulberryShop.cart.render()
        setTimeout(() => {
                   mulberryShop.cart.render()
                   }, 1300)
      }
      $('.addExtended').on('click', function(){
        var id = $(this).attr('prodid');
        var qty = $(this).parent().parent().find('.miniCartCard__quant').find('input').val();
        var timestamp = $(this).attr('timestamp');
        Extend.modal.open({
          referenceId: id,
          /**
           * This callback will be triggered both when a user declines the offer and if
           * they choose a plan.  If a plan is chosen, it will be passed into the
           * callback function, otherwise it will be undefined.
           */
      
          onClose: function(plan, product) {
            if (plan && product) {
              
              var planTitle = plan.planId+'-'+plan.price;
              var result = extendLibrary.filter(obj => {
                return obj.title === planTitle;
              });
              var extendId = result[0].id;
              var extendNum = extendId / 1;
              
              CartJS.addItem(extendNum, qty, {"_timestamp":timestamp});
              
            }
          },
        });
      });
     
      
      
      $('.addInstall').on('click', function(){
        var id = $(this).attr('prodid');
        var qty = $(this).parent().parent().find('.miniCartCard__quant').find('input').val();
        var timestamp = $(this).attr('timestamp');
        CartJS.addItem(id, qty, {"_timestamp":timestamp});
      });
      
     
      $('.removeExtend__button, .removeInstall__button').on('click', function(){
        var index = $(this).parent().parent().attr('prodindex');
        index = index / 1 + 1;
        console.log(index);
        CartJS.removeItem(index);
      });
      
      $('body').on('mulberry-remove-and-sync', () => {
		fetch('/cart.js', {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (cart) {
          cart.json().then(function (firstCart) {           
             mulberryShop.removeDetachedWarranty(firstCart)
             .then(newCart => {
             	mulberryShop.cart.syncQuantities(newCart)
				  .then(content => {
				let price = $('#ajax-cart-subtotal').text()
                let real_price = `${content.total_price /100}`
                if (price != content.total_price / 100) {
                    $('#ajax-cart-subtotal').text(`$${real_price}.00`)
                    $('#mulberry-header-count2').text(content.item_count)
                    mulberryShop.cart.render();
                  if (window.location.href.indexOf('/cart') != -1) {
                    $('#mulberry-target-total').text(`$${real_price}.00`)
                  } else {
					$('#mulberry-slideout-cart-total').text(content.item_count)                  
                  }
                }

                  })
             })
          });
        });
    })

    
    document.addEventListener('mulberry-shopify:warranty-added', async () => {
      setTimeout(() => {
        $('body').trigger('mulberry-remove-and-sync')    	           
      }, 1000)
    });

      
      $('.miniCartCard__delete').on('click', function(){
        var parentId = $(this).attr('data-id');        
        var parentIndex = $(this).attr('parent-index');
        parentIndex = parentIndex / 1 + 1
        var warrantyIndex = $(this).attr('warranty-index');
        warrantyIndex = warrantyIndex / 1 + 1
        var installIndex = $(this).attr('install-index');
        installIndex = installIndex / 1 + 1
        
        if (parentId) {
            CartJS.removeItemById(parentId)
            .then(res => {
                         $('body').trigger('mulberry-remove-and-sync')
            })
        } else {
        CartJS.removeItem(parentIndex)
            .then(res => {
                         $('body').trigger('mulberry-remove-and-sync')
            })
        
        if (typeof warrantyIndex !== typeof undefined && attr !== false) {
          CartJS.removeItem(warrantyIndex);
        }
        
        if (typeof installIndex !== typeof undefined && attr !== false) {
          CartJS.removeItem(installIndex);
        } 
        }
      });
      
      var cartData = CartJS.cart.items;
      $('.miniUpsellProd__title').each(function(){
        var thisThing = $(this).parent().parent().parent();
        var thisTitle = $(this).text().trim();
        var score = 0;
        for (i=0;i<cartData.length;i++){
          if (thisTitle == cartData[i].product_title){
            score++;
          }
      	}
        if (score > 0){
          thisThing.hide();
        }
        else{
          thisThing.show();
        }
      });
      
      $('.miniCartCard__quant input').on('change', function(){
        var qty = $(this).val();
        var parentIndex = $(this).parent().parent().parent().find('.miniCartCard__delete').attr('parent-index');
        parentIndex = parentIndex / 1 + 1;
        
        CartJS.updateItem(parentIndex, qty)
            .then(res => {
				$('body').trigger('mulberry-remove-and-sync')
            })
       
       
        var warranty = $(this).parent().parent().parent().parent().parent().find('.removeExtend');
        if (warranty.is(':visible')){
          var warrantyIndex = warranty.attr('prodindex');
          warrantyIndex = warrantyIndex / 1 + 1;
          CartJS.updateItem(warrantyIndex, qty);
        }
    
        var install = $(this).parent().parent().parent().parent().parent().find('.removeInstall');
        if (install.is(':visible')){
          var installIndex = install.attr('prodindex');
          installIndex = installIndex / 1 + 1;
          CartJS.updateItem(installIndex, qty);
        }
      });
      
      $('.miniCartCard__minus').on('click', function(){
        var target = $(this).parent().find('input');
        var qty = target.val();
        qty = qty / 1 - 1;
        target.val(qty);
        target.attr('value', qty);
        target.change();
      });
      
      $('.miniCartCard__plus').on('click', function(){
        var target = $(this).parent().find('input');
        var qty = target.val();
        qty = qty / 1 + 1;
        target.val(qty);
        target.attr('value', qty);
        target.change();
      });
      
    }
    
    
    var templateHTMLFull = $('.cart__list').html();
    
    function buildProdCardFull(parentIndex, childIndex1, childIndex2){
      
      var parentProd = CartJS.cart.items[parentIndex];
      
      if (childIndex1 != 'empty'){
      var childProd1 = CartJS.cart.items[childIndex1];
      }
      else{
        var childProd1 = false
      }
      
      if (childIndex2 != 'empty'){
      	var childProd2 = CartJS.cart.items[childIndex2];
      }
      else{
        var childProd2 = false
      }
      
      var obj = {
        'image':parentProd.featured_image.url,
        'alt':parentProd.featured_image.alt,
        'timestamp':parentProd.properties._timestamp,
        'parent_index':parentIndex,
        'title':parentProd.product_title,
        'variant':parentProd.variant_title,
        'qty':parentProd.quantity,
        'price':parentProd.price,
        'parent_id':parentProd.id,
        'warranty_price_empty':getExtendPriceString(parentIndex),
        'install_price_empty':getInstallPriceString(parentIndex),
        'install_id':getInstallVariantId(parentIndex)
      }
      if (childProd1){
      	obj['warranty_index'] = childIndex1;
        obj['warranty_title'] = childProd1.product_title;
        obj['warranty_price'] = childProd1.price;
      }
      if (childProd2){
        obj['install_index'] = childIndex2;
        obj['install_title'] = childProd2.product_title;
        obj['install_price'] = childProd2.price;
      }
      
      let templateClone = $.parseHTML(templateHTMLFull);
      
      $(templateClone).find('.cartCard__img').attr('src', obj.image);
      $(templateClone).find('.cartCard__img').attr('alt', obj.alt);
      $(templateClone).find('.cartCard__delete').attr('parent-index', obj.parent_index);
      $(templateClone).find('.cartCard__delete').attr('data-id', obj.parent_id);      
      $(templateClone).find('.cartCard__title').text(obj.title);
      $(templateClone).find('.cartCard__variant').text(obj.variant);
      $(templateClone).find('.cartCard__quant').find('input').val(obj.qty).attr('value', obj.qty);
      var displayPrice = (parseFloat(obj.price) / 100).toFixed(2);
      $(templateClone).find('.cartCard__priceRow').find('span').text("$"+displayPrice);
      $(templateClone).find('.cart__addExtended').attr('prodid', obj.parent_id);
      $(templateClone).find('.cart__addExtended').attr('timestamp', obj.timestamp);
      $(templateClone).find('.cart__addExtended__price').text(obj.warranty_price_empty);
      $(templateClone).find('.cart__addInstall').attr('prodid', obj.install_id);
      $(templateClone).find('.cart__addInstall').attr('timestamp', obj.timestamp);
      $(templateClone).find('.cart__addInstall__price').text(obj.install_price_empty);
      $(templateClone).attr('data-mulberry-variant-id', obj.parent_id);
      $(templateClone).find('.cartCard__addOns').html(`<warranty-details data-variant-id="${obj.parent_id}"></warranty-details>`);
      if (parentProd.vendor == 'Mulberry') {
        $(templateClone).attr('style', 'display: none');
      }
      if (obj.install_id == false){
        $(templateClone).find('.cart__addInstall').hide();
      }
    
      if (obj.warranty_price_empty == false){
        $(templateClone).find('.cart__addExtended').hide();
      }
    
      if (obj.hasOwnProperty('warranty_index')){
        $(templateClone).find('.cart__addExtended').hide();
        $(templateClone).find('.cartCard__delete').attr('warranty-index', obj.warranty_index);
        $(templateClone).find('.cart__removeExtend').attr('prodindex', obj.warranty_index);
        $(templateClone).find('.cart__removeExtend__title').text(obj.warranty_title);
        var extendPrice = (parseFloat(obj.warranty_price) / 100).toFixed(2);
      	$(templateClone).find('.cart__removeExtend__price').text('$'+extendPrice);
      }
      else{
        $(templateClone).find('.cart__removeExtend').hide();
      }
     
      if (obj.hasOwnProperty('install_index')){
        $(templateClone).find('.cart__addInstall').hide();
        $(templateClone).find('.cartCard__delete').attr('install-index', obj.install_index);
        $(templateClone).find('.cart__removeInstall').attr('prodindex', obj.install_index);
        $(templateClone).find('.cart__removeInstall__title').text(obj.install_title);
        var installPrice = (parseFloat(obj.install_price) / 100).toFixed(2);
      	$(templateClone).find('.cart__removeInstall__price').text('$'+installPrice);
      }
      else{
        $(templateClone).find('.cart__removeInstall').hide();
      }
      
      return templateClone;
    }
    
    function renderNewCartFull(){
      $('.cart__list').html('');
      var newCartHTML = '';
      var grouped = groupByTimestamps();
      for (i=0;i<grouped.length;i++){
        
        if (grouped[i].warranty == null){
          var warranty = 'empty';
        }
        else{
          var warranty = grouped[i].warranty;
        }
        
        if (grouped[i].install == null){
          var install = 'empty';
        }
        else{
          var install = grouped[i].install;
        }
        
        
          newCartHTML += htmlToSource(buildProdCardFull(grouped[i].index, warranty, install));
      }
     
      $('.cart__addExtended').on('click', function(e){
        e.preventDefault();
        var id = $(this).attr('prodid');
        var qty = $(this).parent().parent().find('.cartCard__quant').find('input').val();
        var timestamp = $(this).attr('timestamp');
        Extend.modal.open({
          referenceId: id,
          /**
           * This callback will be triggered both when a user declines the offer and if
           * they choose a plan.  If a plan is chosen, it will be passed into the
           * callback function, otherwise it will be undefined.
           */
   
          onClose: function(plan, product) {
            if (plan && product) {
              
              var planTitle = plan.planId+'-'+plan.price;
              var result = extendLibrary.filter(obj => {
                return obj.title === planTitle;
              });
              var extendId = result[0].id;
              var extendNum = extendId / 1;
              
              CartJS.addItem(extendNum, qty, {"_timestamp":timestamp});
              
            }
          },
        });
      });
     
      
      $('.cart__addInstall').on('click', function(e){
        e.preventDefault();
        if(e.target.tagName == "SPAN"){
          $(".install-pop-up").fadeIn("fast");
          return;
        }
        var id = $(this).attr('prodid');
        var qty = $(this).parent().parent().find('.cartCard__quant').find('input').val();
        var timestamp = $(this).attr('timestamp');
        CartJS.addItem(id, qty, {"_timestamp":timestamp});
        
      });
    
     
      $('.cart__removeExtend__button').on('click', function(e){
        e.preventDefault();
        var index = $(this).parent().parent().parent().attr('prodindex');
        index = index / 1 + 1;
        console.log(index);
        CartJS.removeItem(index);
      });
      
      
      $('.cart__removeInstall__button').on('click', function(e){
        e.preventDefault();
        var index = $(this).parent().parent().parent().attr('prodindex');
        index = index / 1 + 1;
        console.log(index);
        CartJS.removeItem(index);
      });
      
      
      setTimeout(() => {
		$('.cartCard__delete').on('click', function(e){
          e.preventDefault();
          var parentId = $(this).attr('data-id');
          var parentIndex = $(this).attr('parent-index');
          parentIndex = parentIndex / 1 + 1
          var warrantyIndex = $(this).attr('warranty-index');
          warrantyIndex = warrantyIndex / 1 + 1
          var installIndex = $(this).attr('install-index');
          installIndex = installIndex / 1 + 1

          if (parentId) {
            CartJS.removeItemById(parentId)
                    .then(res => {
        $('body').trigger('mulberry-remove-and-sync')
        })
          } else {

          CartJS.removeItem(parentIndex)
                    .then(res => {
        $('body').trigger('mulberry-remove-and-sync')
        })

          if (typeof warrantyIndex !== typeof undefined && attr !== false) {
            CartJS.removeItem(warrantyIndex);
          }

          if (typeof installIndex !== typeof undefined && attr !== false) {
            CartJS.removeItem(installIndex);
          }
          }
//         setTimeout(() => {
//                    $('body').trigger('mulberry-remove-and-sync')
//                    }, 1000)
        });           
      }, 1000)
      
      
      setTimeout(() => {
       $('.cartCard__quant input').on('change', function(e){
        e.preventDefault();
        var qty = $(this).val();
        var parentIndex = $(this).parent().parent().find('.cartCard__delete').attr('parent-index');
        var parentId = $(this).parent().parent().find('.cartCard__delete').attr('data-id');
        parentIndex = parentIndex / 1 + 1;
        CartJS.updateItemById(parentId, qty)
        .then(res => {
        $('body').trigger('mulberry-remove-and-sync')
        })
        
        var warranty = $(this).parent().parent().parent().parent().find('.cart__removeExtend');
        if (warranty.is(':visible')){
          var warrantyIndex = warranty.attr('prodindex');
          warrantyIndex = warrantyIndex / 1 + 1;
          CartJS.updateItem(warrantyIndex, qty);
        }
       
        
        var install = $(this).parent().parent().parent().parent().find('.cart__removeInstall');
        if (install.is(':visible')){
          var installIndex = install.attr('prodindex');
          installIndex = installIndex / 1 + 1;
          CartJS.updateItem(installIndex, qty);
        }
      });
      
      $('.cartCard__minus').on('click', function(e){
        e.preventDefault();
        var target = $(this).parent().find('input');
        var qty = target.val();
        qty = qty / 1 - 1;
        target.val(qty);
        target.attr('value', qty);
        target.change();
      });
      
      $('.cartCard__plus').on('click', function(e){
        e.preventDefault();
        var target = $(this).parent().find('input');
        var qty = target.val();
        qty = qty / 1 + 1;
        target.val(qty);
        target.attr('value', qty);
        target.change();
      });          
      }, 1000)
      
    $('.cart__list').html(newCartHTML);      
//       setTimeout(() => {
//                        if (window && window.mulberryShop) {
//         mulberryShop.cart.render()
//       }
//                  }, 4000)
    }
    
    //observe for any changes with a lightweight interger comparison on loop
    var cartObserveCode = CartJS.cart.item_count * CartJS.cart.total_price;
    setInterval(function(){
      var cartCompare = CartJS.cart.item_count * CartJS.cart.total_price;
      if (cartObserveCode != cartCompare){
        cartObserveCode = cartCompare
        renderNewCart();
        if ($('#shopify-section-sm-cart').length){
           renderNewCartFull();
        }
        
        
      }
    }, 10);
    renderNewCart();
    if ($('#shopify-section-sm-cart').length){
      renderNewCartFull();
    }
    
  });
})(jQuery);
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch. 